<template>
  <div class="container h-100">
    <loading :active.sync="isLoading"
             :is-full-page="isFullPage"></loading>
    <b-alert variant="danger"
             dismissible
             :show="showDismissibleAlert"
             @dismissed="showDismissibleAlert=false">
      {{alertMessage}}
    </b-alert>
    <div class="row h-100 justify-content-center align-items-center">
    <div class="col-md-6">
    <form class="form-signin">
      <div class="text-center mb-4">
        <!--<img class="mb-4" src="" alt="" width="72" height="72">-->
        <h1 class="h3 mb-3 font-weight-normal">YDS, YÖKDİL Sınav Analizi sayfası </h1>
        <p>Yanlış yaptığınız soruların video çözümlerini izleyerek, eksiklerinizi öğrenin</p>
        <p>Hangi Ankara Dil Akademisi eğitiminin sizi başarıya ulaştıracağını öğrenin. Gerekirse öğretmenlerinizden, geridönütler alın.</p>
        <p>Sınav Analizi girişi için ankaradil.com üyesi olmalısınız. Daha önce ankaradil.com adresinden üye olduysanız şifrenizle giriş yapabilirsiniz. Eğer üye olmadıysanız <a href="/uyeol">ÜYE OL</a> bağlantısı ile üyelik oluşturabilirsiniz. </p>
        <p>Sınav değerlendirmenizi sadece ankaradil.com aktif öğrencisiyseniz veya öğretmenlerimiz size bir aktivasyon kodu verdiyse oluşturabilirsiniz!</p>
      </div>

      <div class="form-label-group">
        <label for="inputEmail">Ankaradil.com Eposta Adresiniz</label>
        <input v-model="username" autocomplete="username" type="email" id="inputEmail" class="form-control" placeholder="Eposta Adresi" required="" autofocus="">
      </div>

      <div class="form-label-group">
        <label for="inputPassword">Ankaradil.com Şifreniz</label>
        <input v-model="password" autocomplete="current-password" type="password" id="inputPassword" class="form-control" placeholder="Şifre" required="">

      </div>

      <div class="checkbox mb-3">
        <label>
          <!--<input type="checkbox" value="remember-me"> Remember me-->
         </label>
      </div>
      <button class="btn btn-lg btn-primary btn-block" v-on:click="signon" >Giriş Yap</button>
      <p class="mt-5 mb-3 text-muted text-center">© 2018 <a href="http://www.code4edu.com">code4edu.com</a></p>
    </form>
    </div>
  </div>
  </div>
</template>

<script>
import axios from 'axios'
import { mapActions } from 'vuex'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  name: 'Login',
  data: () => {
    return {
      isLoading: false,
      username: '',
      password: '',
      alertMessage: '',
      showDismissibleAlert: false,
      isFullPage: true
    }
  },
  components: {
    Loading
  },
  methods: {
    ...mapActions([
      'Login_ACTION'
    ]),
    test: function (e) {
      console.log('Test')
      e.preventDefault()
    },
    signon: function (e) {
      this.isLoading = true
      this.showDismissibleAlert = false
      if (this.username === '' || this.password === '') {
        this.alertMessage = 'Tüm alanların doldurulması zorunludur.'
        this.showDismissibleAlert = true
        this.isLoading = false
        return
      }
      axios.post(this.$serviceAddress + 'api/v5/checkuser', {
        username: this.username,
        // password: this.password,
        password: unescape(encodeURIComponent(this.password)),
        group: 19
      }, {
        auth: {
          username: this.username,
          password: unescape(encodeURIComponent(this.password))
        }
      }).then(response => {
        this.isLoading = false
        let data = response.data
        if (data.result === 1) {
          data.router = this.$router
          this.Login_ACTION(data)
          // this.$router.push('/usermain')
          //
        } else {
          this.alertMessage = 'Kullanıcı Girişi Yapılırken bir hata oluştu :' + data.err
          this.showDismissibleAlert = true
        }
      })
        .catch(e => {
          this.isLoading = false
          this.alertMessage = 'Kullanıcı Oluşturulurken bir hata oluştu :' + e.message
          this.showDismissibleAlert = true
        })
      e.preventDefault()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Login.vue